import { create } from 'zustand';
const useShareLinkOutput = create(() => ({
    sharePhase: 'idle',
    errorMessage: undefined,
}));
const reactiveOutput = {
    useSharePhase: () => {
        return useShareLinkOutput((state) => state.sharePhase);
    },
    useErrorMessage: () => {
        return useShareLinkOutput((state) => state.errorMessage);
    },
};
export class ShareLinkServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setPhase(sharePhase) {
        useShareLinkOutput.setState({ sharePhase, errorMessage: undefined });
    }
    setError(errorMessage) {
        useShareLinkOutput.setState({ sharePhase: 'error', errorMessage });
    }
}
